import { render } from "./profileMobile.vue?vue&type=template&id=22c3db1a&scoped=true"
import script from "./profileMobile.vue?vue&type=script&lang=js"
export * from "./profileMobile.vue?vue&type=script&lang=js"

import "./profileMobile.vue?vue&type=style&index=0&id=22c3db1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c3db1a"]])

export default __exports__